import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import {
  getAllDocumentTemplates,
  getDocumentTemplateStats,
  getFilteredDocumentTemplates,
  getConditionalDocumentTemplateTypes,
} from 'actions/landlordDocumentTemplatesActions';
import { getProperties } from 'actions/landlordPropertiesActions';
import { getSignableDocClientId } from 'actions/landlordSignableDocActions';

import DocumentTemplatesTable from './DocumentTemplatesTable';
import { featureEnabled } from 'helpers/ToggleBot';

export default connect(
  store => ({
    properties: store.landlordProperties.properties,
    documentTemplates: store.landlordDocumentTemplates.documentTemplates,
    templateCounts: store.landlordDocumentTemplates.templateCounts,
    fetchingDocumentTemplates: store.landlordDocumentTemplates.fetchingDocumentTemplates,
  }),
  {
    getProperties,
    getSignableDocClientId,
    getAllDocumentTemplates,
    getDocumentTemplateStats,
    getFilteredDocumentTemplates,
    getConditionalDocumentTemplateTypes,
  }
)(
  class DocumentTemplates extends Component {
    componentDidMount = () => {
      if (!featureEnabled('custom_lease_creator')) {
        browserHistory.push('/companies/dashboard');
        return;
      }
      this.fetchDocumentTemplatesAndStats();
      this.props.getProperties({ for_multiselect: true });
      this.props.getSignableDocClientId();
      this.props.getConditionalDocumentTemplateTypes();
    };

    fetchDocumentTemplatesAndStats = () => {
      this.props.getAllDocumentTemplates();
      this.props.getDocumentTemplateStats();
    };

    fetchDocumentTemplateById = row_data => {
      const documentTemplateId = row_data.original_id ? row_data.original_id : row_data.id;
      browserHistory.push(`/companies/document_templates/${documentTemplateId}`);
    };

    render() {
      return (
        <DocumentTemplatesTable
          data={this.props.documentTemplates}
          getFilteredDocumentTemplates={this.props.getFilteredDocumentTemplates}
          getAllDocumentTemplates={this.props.getAllDocumentTemplates}
          fetchDocumentTemplatesAndStats={this.fetchDocumentTemplatesAndStats}
          isLoading={this.props.fetchingDocumentTemplates}
          properties={this.props.properties}
          fetchDocumentTemplateById={this.fetchDocumentTemplateById}
          templateCounts={this.props.templateCounts}
        />
      );
    }
  }
);
